import ApiService from '@/services/core/api.service'

const VehicleService = {
  async get (query) {
    return ApiService.get(`logistics-officer/vehicles?${query}`)
  },

  async post (payload) {
    return ApiService.post('logistics-officer/vehicles', payload)
  },

  async put (payload) {
    return ApiService.put(`logistics-officer/vehicles/${payload.id}`, payload)
  }
}

export default VehicleService
